import { render, staticRenderFns } from "./ViewRecoveryCodes.vue?vue&type=template&id=7165f380&scoped=true&"
import script from "./ViewRecoveryCodes.vue?vue&type=script&lang=js&"
export * from "./ViewRecoveryCodes.vue?vue&type=script&lang=js&"
import style1 from "./ViewRecoveryCodes.vue?vue&type=style&index=1&id=7165f380&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7165f380",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
